//api 接口处理
import request from "@/utils/request.js";
export default {
    //登录验证码
    getLoginCode(param) {
        return request.post("merchant/login/loginCode", param);
    },
    //管理员登录
    login(param) {
        return request.post("merchant/login/index", param);
    },
    merchantLS(param) {
        return request.post("merchant/home/manageMerchant", param, false, true);
    },
    //左侧菜单
    getMeauList(param) {
        return request.post("merchant/home/index", param, false, true);
    },
    //文件上传
    imgUpload(param) {
        return request.post("merchant/home/imgUpload", param, false, true);
    },
    //OSS
    getOssToken() {
        return request.post("scrm/index/ossUpload", {}, false, true);
    },
    //项目预览
    qrcodePreview(param) {
        return request.post("merchant/home/getQrCode", param, false, true);
    },
    //企业微信扫码登录
    workLogin(param) {
        return request.post("merchant/WorkAuth/workLogin", param);
    },
    //全局静态参数
    globalConfig(param) {
        return request.post("merchant/home/globalConfig", param, false, true);
    },
    //全局动态参数
    dynamicConfig(param) {
        return request.post("merchant/home/dynamicConfig", param, false, true);
    },
    //批量导入
    excelInCustomer(param) {
        return request.post("merchant/Operation.excel/excelInCustomer", param, false, true);
    },
    //企业微信弹窗表单
    synchroSercet(param) {
        return request.post("merchant/Work.initialize/synchroSercet", param, false, true);
    },
    //部门信息
    synchroDepartment(param) {
        return request.post("merchant/Work.initialize/synchroDepartment", param, false, true);
    },
    //员工信息
    synchroStaff(param) {
        return request.post("merchant/Work.initialize/synchroStaff", param, false, true);
    },
    //企业标签
    synchroLabel(param) {
        return request.post("merchant/Work.initialize/synchroLabel", param, false, true);
    },
    //企业客户
    synchroCustomer(param) {
        return request.post("merchant/Work.initialize/synchroCustomer", param, false, true);
    },
    //企业客户
    updateCorpToken(param) {
        return request.post("merchant/Work.initialize/updateCorpToken", param, false, true);
    },
    //切换门店
    switchMerchant(param) {
        return request.post("merchant/home/switchMerchant", param, false, true);
    },
    //修改密码
    changePassword(param) {
        return request.post("merchant/home/changePassword", param, false, true);
    },
    //初始化密码
    initialPassword(param) {
        return request.post("merchant/Authority.account/initialPassword", param, false, true);
    },

}